export default {
  title: 'Badge',
  actions: {
    create: 'create a badge',
    add: 'add badge',
    'add-new': 'Add new badge.',
    'link-event': 'link an event',
    'add-child': 'child badge',
    'check-child-badge': 'Check the action(s) of the child badge(s).',
    'check-infos': 'To make this badge unlockable, you must',
    'badge-unblockable': 'By completing the following action(s)',
    'badge-unblockable-children': 'By completing each of the child badges.',
    'see': 'see badges',
    'hide': 'hide badges'
  },
  empty: {
    title: 'No badge',
    message: 'To create a badge, nothing could be easier, just click on the following link:'
  },
  state: {
    published: 'published',
    testing: 'testing',
    terminated: 'terminated',
    unlockable: 'Unlockable',
    lockable: 'Blocked',
    publishedAll: 'badges published!',
    blockedWarning: 'The following badges were published, but need an event linking or child badges. ('
  },
  modal: {
    fields: {
      name: 'Name',
      maxachieved: 'Restrict the number of badges',
      period: 'Restrict the period',
      date: {
        start: 'Start',
        end: 'End'
      }
    },
    create: {
      title: 'Create a badge'
    },
    edit: {
      title: 'Edit a badge'
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/en/badge.js